import { Box, Typography, useTheme } from '@mui/material';
import IconInfo from 'shared/icons/iconInfo';
import IconLogo from 'shared/icons/logo';
import React from 'react';

export default function LoginHeader({
  text,
  isError,
}: {
  text: string;
  isError?: boolean;
}) {
  const theme = useTheme();

  return (
    <>
      <IconLogo></IconLogo>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        {isError && (
          <IconInfo
            sizeKey="20x20"
            extColor={theme.palette.error.main}
          ></IconInfo>
        )}
        <Typography
          variant="f24"
          color={
            isError ? theme.palette.error.main : theme.palette.text.primary
          }
          sx={{ fontWeight: 'bold' }}
        >
          {text}
        </Typography>
      </Box>
    </>
  );
}
